import { createWithEqualityFn as create } from 'zustand/traditional';
import { persist } from 'zustand/middleware';

export type ColorSchemeType = 'dark' | 'light' | 'system';

interface ColorSchemeState {
  colorScheme: ColorSchemeType;
  switchScheme: (colorScheme: ColorSchemeState['colorScheme']) => void;
}

export const useColorSchemeStore = create<ColorSchemeState>()(
  persist(
    (set) => ({
      colorScheme: 'system',
      switchScheme: (colorScheme) => set({ colorScheme }),
    }),
    {
      name: 'colorScheme',
    },
  ),
);